import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ResourceSuggestionsPage from "@/pages/admin/ResourceSuggestionsPage";

export const Route = createFileRoute("/_admin/admin/resource-suggestions")({
  head: () => pageHead("Admin · Resource Suggestions", "AKIVA admin · resource suggestions portal.", "/admin/resource-suggestions", true),
  component: ResourceSuggestionsPage,
});
